<template>
    <div id="cooperationCase">
        <!--banner区域-->
        <div class="bannerWrap">
            <div class="contentWrap">
                <img src="../../assets/img/cooperationCase/banner配图.png" class="bgImg"/>
                <div class="content">
                    <div class="contentTitle">合作案例</div>
                    <div class="contentVal">
                        <span>探索和耕耘企业级⼤数据服务领域</span>
                        <span>构建以数据为基础的⽣态，不断为合作伙伴创造价值</span>
                    </div>
                </div>
            </div>
        </div>
        <!--内容区-->
        <!--合作案例1-->
        <div class="conWrap conWrap1">
            <div class="cooperationCaseBox">
                <div class="leftImgWrap">
                    <img src="../../assets/img/cooperationCase/案例1.png" class="leftImg"/>
                    <div class="imgConWrap imgConWrap1">
                        <div class="conTitle">浦发银行信用卡获客</div>
                        <div class="conVal">
                            <span>投放媒体：广点通、今日头条、搜狐汇算</span>
                            <span>投放目标：达标客户要求CPA和核卡量</span>
                        </div>
                    </div>
                    <div class="imgConWrap imgConWrap2">
                        <div class="conTitle">中信银行信用卡投放策略</div>
                        <div class="conVal">
                            <span>投放媒体：广点通、华为、今日头条</span>
                            <span>投放目标：在客户的成本考核内，提升素材的点击率和转化率</span>
                        </div>
                    </div>
                </div>
                <div class="rightCon">
                    <div class="rightConTitle">案例一</div>
                    <div class="rightConSecTitle">赋能金融行业</div>
                    <div class="conBox firstBox">
                        <div class="conBoxTitle">浦发银行信用卡获客投放策略</div>
                        <div class="conBoxVal">
                            根据每个渠道不同的人群属性特点，结合产品的功能特性，规划出产品媒体的受众人群，比如年龄、学历、兴趣爱好等方面，从而确定广告材料的风格特点，以此来提高各个环节的转化率，增加广告投放产出比。定期进行产品信息以及流量节日热点的结合，从而使受众对我们的广告产生新鲜度，一方面提升品牌意识，一方面促成更好的转化
                        </div>
                    </div>
                    <div class="conBox">
                        <div class="conBoxTitle">投放结果</div>
                        <div class="conBoxVal">
                            常规投放填写表单率为5%，通过分析受众人群以及结合热点，转化提升10%
                        </div>
                    </div>
                    <div class="conBox">
                        <div class="conBoxTitle">中信银行信用卡投放策略</div>
                        <div class="conBoxVal">
                            分析中信银行产品特征，中信银行信用卡的优势在于卡面极其丰富，充满多样性，比较符合年轻人的喜好需求，根据中信银行这一特点，挑选不同的卡种面向人群，定向投放对应人群，从而能更好的抓住目标客群，并且进行有价值的转化，达到最终客户要求目标，并且在这个基础上，进行多渠道的投放探索，扩大整体项目量级
                        </div>
                    </div>
                    <div class="conBox">
                        <div class="conBoxTitle">投放结果</div>
                        <div class="conBoxVal">
                            成本在客户成本考核以内，素材的点击率提升到了1.5%，转化率提升10%
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--合作案例2-->
        <div class="conWrap conWrap2">
            <div class="cooperationCaseBox">
                <div class="rightCon">
                    <div class="rightConTitle">案例二</div>
                    <div class="rightConSecTitle">赋能APP获客</div>
                    <div class="conBox firstBox">
                        <div class="conBoxTitle">酷匠阅读App推广投放策略</div>
                        <div class="conBoxVal">
                            结合目标用户在appstore上的搜索习惯，制定产品的关键词库，并根据用户喜好和产品特性，优化了产品简介和图文介绍。通过了解竞品的投放策略，围绕产品关键词做打榜优化，并监测到榜率和新增用户数
                        </div>
                    </div>
                    <div class="conBox">
                        <div class="conBoxTitle">投放结果</div>
                        <div class="conBoxVal">
                            cpa新增用户成本低至1元，比同行少150%
                        </div>
                    </div>
                </div>
                <div class="leftImgWrap">
                    <img src="../../assets/img/cooperationCase/案例2.png" class="leftImg"/>
                    <div class="imgConWrap imgConWrap1">
                        <div class="conTitle">项目：酷匠阅读App推广投放</div>
                        <div class="conVal">
                            <span>投放媒体：Appstore</span>
                            <span>投放目标：控制获客成本</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--合作案例3-->
        <div class="conWrap conWrap3">
            <div class="cooperationCaseBox">
                <div class="leftImgWrap">
                    <img src="../../assets/img/cooperationCase/案例3.png" class="leftImg"/>
                    <div class="imgConWrap imgConWrap1">
                        <div class="conTitle">腾讯游戏获客</div>
                        <div class="conVal">
                            <span>广点通、今日头条、信息流等</span>
                            <span>投放目标：低于客户要求cpa，达到客户要求arpu</span>
                        </div>
                    </div>
                </div>
                <div class="rightCon">
                    <div class="rightConTitle">案例三</div>
                    <div class="rightConSecTitle">赋能精品游戏</div>
                    <div class="conBox firstBox">
                        <div class="conBoxTitle">腾讯游戏获客投放策略</div>
                        <div class="conBoxVal">
                            根据游戏产品类型和策略玩法定位目标用户年龄段，地域，性别，兴趣，游戏消费能力等基础标签，结合大数据DMP精准游戏种子人群包并拓展相似游戏玩家画像，触达客户产品的目标用户和潜在用户，实现精准投放。同时配合客户在重点节假日、周年庆期间的游戏运营活动调整投放策略和节奏
                        </div>
                    </div>
                    <div class="conBox">
                        <div class="conBoxTitle">考核指标</div>
                        <div class="conBoxVal">
                            留存率，付费率，付费arpu值
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "cooperationCase",
        mounted() {
            /*淡入淡出效果*/
            window.addEventListener('scroll', this.scrollFun);
            this.scrollFun();
        },
        methods: {
            scrollFun() {
                this.$animate(document.getElementsByClassName("content")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("cooperationCaseBox")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("cooperationCaseBox")[1], "fadeInUp");
                this.$animate(document.getElementsByClassName("cooperationCaseBox")[2], "fadeInUp");
            }
        },
        beforeDestroy() {
            /*销毁监听*/
            window.removeEventListener('scroll', this.scrollFun);
        }
    }
</script>

<style lang="scss" scoped>
    #cooperationCase {
        .bannerWrap {
            background: #010101;

            .contentWrap {
                .bgImg {
                    position: absolute;
                    top: 50%;
                    right: 100px;
                    transform: translateY(-50%);
                }
            }
        }

        .conWrap1 {
            background: url("../../assets/img/cooperationCase/合作案例1.png") no-repeat center;
            background-size: cover;

            .imgConWrap {
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
            }

            .imgConWrap1 {
                top: 231px;

                .conTitle {
                    margin-bottom: 22px;
                    color: #FFFFFF;
                }
            }

            .imgConWrap2 {
                top: 516px;

                .conTitle {
                    margin-bottom: 20px;
                    color: #FFFFFF;
                }
            }
        }

        .conWrap2 {
            background: url("../../assets/img/cooperationCase/合作案例2.png") no-repeat center;
            background-size: cover;

            .imgConWrap {
                position: absolute;
                left: 40px;
            }

            .imgConWrap1 {
                top: 387px;

                .conTitle {
                    margin-bottom: 21px;
                    font-size: 18px;
                    color: #152346;
                }

                .conVal {
                    color: #152346 !important;
                }
            }
        }

        .conWrap3 {
            background: url("../../assets/img/cooperationCase/合作案例3.png") no-repeat center;
            background-size: cover;
            margin-bottom: 150px;

            .imgConWrap {
                position: absolute;
                left: 65px;
            }

            .imgConWrap1 {
                top: 468px;

                .conTitle {
                    margin-bottom: 22px;
                    font-size: 18px;
                    color: #FFFFFF;
                }
            }
        }

        .conWrap {
            .cooperationCaseBox {
                display: flex;
                justify-content: space-between;
                width: 1200px;
                margin: 0 auto;
                padding-top: 80px;

                .leftImgWrap {
                    position: relative;
                    width: 342px;
                    height: 692px;

                    .imgConWrap {
                        .conTitle {
                            font-size: 18px;
                        }

                        .conVal {
                            display: flex;
                            flex-direction: column;
                            width: 216px;
                            line-height: 17px;
                            font-size: 12px;
                            text-align: justify;
                            color: #FFFFFF;
                        }
                    }

                    .leftImg {
                        width: 100%;
                        height: 100%;
                        border-radius: 50px;
                    }
                }


                .rightCon {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    flex-basis: 757px;

                    .rightConTitle {
                        margin-bottom: 8px;
                        font-size: 40px;
                        line-height: 56px;
                        color: #152346;
                    }

                    .rightConSecTitle {
                        opacity: 0.6;
                        margin-bottom: 40px;
                        font-size: 22px;
                        color: #030741;
                    }

                    .conBox {
                        margin-bottom: 40px;

                        .conBoxTitle {
                            margin-bottom: 6px;
                            font-size: 16px;
                            color: #152346;
                        }

                        .conBoxVal {
                            opacity: 0.8;
                            font-size: 12px;
                            color: #152346;
                            line-height: 24px;
                        }
                    }

                    .firstBox {
                        margin-bottom: 16px;
                    }
                }
            }
        }
    }
</style>